import * as firebase from "firebase/app";
import "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { useReducer, useEffect, useContext } from "react";
import User from "../../models/user.model";
import AuthService from "../auth.service";
import GlobalContext from "../../state/GlobalContext";

export default () => {
  const [user, initializing, error] = useAuthState(firebase.auth());
  const { session } = useContext(GlobalContext);
  const [state, setState] = useReducer(
    (oldState, newState) => ({ ...oldState, ...newState }),
    { user: null, init: true, error: undefined }
  );
  if (error) {
    return [user, initializing, error];
  }

  useEffect(() => {
    const buildUser = async () => {
      try {
        const profile = await AuthService.getProfile(user.uid);
        const resultUser = new User(user, profile).toSubClass();
        return { init: false, user: resultUser, error: undefined };
      } catch (e) {
        return { user: null, init: false, error: e };
      }
    };
    if (!initializing) {
      if (user && state.user === null) {
        buildUser().then(setState);
      } else {
        if (session.state.user === undefined) {
          session.dispatch({
            type: "NULL_USER"
          });
          setState({ ...state, init: false });
        }
      }
    }
  }, [initializing]);

  return [state.user, state.init, state.error];
};
